"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchArrayBuffer = fetchArrayBuffer;
async function fetchArrayBuffer(url) {
    const result = await fetch(url);
    return result.arrayBuffer();
}
//# sourceMappingURL=fetchArrayBuffer.js.map